import { render } from "./MaterialFab.vue?vue&type=template&id=ef4b773a&scoped=true"
import script from "./MaterialFab.vue?vue&type=script&lang=js"
export * from "./MaterialFab.vue?vue&type=script&lang=js"

import "./MaterialFab.vue?vue&type=style&index=0&id=ef4b773a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Portal/portal-partner-deploy-to-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4b773a"]])

export default __exports__